export default {
        getOpenDraws(state) {
            return state.open_draws
        }

 }